import AbstractController from '../../../../../../ig_template/Resources/Public/Src/Js/Controller/AbstractController';
import Controller from '../../../../../../ig_template/Resources/Public/Src/Js/Controller/Controller';

/**
 * Map Controller
 *
 * @class
 */
class MapController extends AbstractController {
  /**
   * @constructor
   */
  constructor() {
    super();

    this._registeredMaps = [];

    Controller.registerController(this);
  }

  registerMaps(...maps) {
  	maps.forEach((map) => {
		this._registeredMaps.push(map);
	});
  }

  initializeMaps() {
  	this._registeredMaps.forEach((map) => {
		map.initialize();
	});
  }
}

export default (new MapController);
